import React, { useEffect } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { Typography } from '@mui/material';
import confetti from 'canvas-confetti';
import { usePointsCountingUpFromZero } from './scoreCountUp';

function ScoreReveal({ earnedPoints, answered, ord }) {
    const correct = answered && earnedPoints > 0;
    const reducedMotion = useReducedMotion();
    const displayed = usePointsCountingUpFromZero(correct ? earnedPoints : 0);

    // `ord` identifies the reveal: a repeat SSE snapshot leaves it unchanged,
    // so the confetti below fires once per question, not once per push.
    useEffect(() => {
        if (!correct) return;
        confetti({
            particleCount: 60,
            spread: 70,
            startVelocity: 35,
            origin: { y: 0.6 },
            disableForReducedMotion: true,
        });
    }, [ord, correct]);

    if (!answered) {
        return (
            <Typography data-testid="score-reveal" color="text.secondary" sx={{ mt: 2 }}>
                You didn&apos;t answer this one
            </Typography>
        );
    }

    if (!correct) {
        return (
            <Typography data-testid="score-reveal" color="text.secondary" sx={{ mt: 2, fontWeight: 700 }}>
                +0
            </Typography>
        );
    }

    return (
        <motion.div
            key={ord}
            initial={reducedMotion ? false : { opacity: 0, scale: 0.4 }}
            animate={{ opacity: 1, scale: [0.4, 1.3, 1] }}
            transition={{ duration: 0.5, ease: 'easeOut' }}
        >
            <Typography
                data-testid="score-reveal"
                sx={{ mt: 2, fontWeight: 800, fontSize: '2rem', color: 'success.dark' }}
            >
                +{displayed}
            </Typography>
        </motion.div>
    );
}

export default ScoreReveal;
